module.exports = __webpack_public_path__ + "img/himg1.94ecaf91.jpg";